// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__56y4k","head":"Table_head__pQx0N","col":"Table_col__3lncm"};